import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dropdown-multiselect_label" }
const _hoisted_2 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_3 = { class: "btn-text" }
const _hoisted_4 = {
  key: 0,
  class: "dropdown-menu"
}
const _hoisted_5 = { class: "dropdown-list" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 1,
  class: "error-message"
}

import { ref, watch, computed, onMounted, onBeforeUnmount } from 'vue';
import TooltipComponent from '@/components/common/TooltipComponent/TooltipComponent.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownMultiSelectComponent',
  props: {
  options: {
    type: Array as () => { label: string; value: string }[],
    required: true,
  },
  modelValue: {
    type: Array as () => string[],
    default: () => [],
  },
  placeholder: {
    type: String,
    default: 'Select options',
  },
  label: {
    type: String,
    default: 'Label',
  },
  id: {
    type: String,
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: '',
  },
  tooltip: {
    type: String,
    required: false
  }
},
  emits: ['updateFilters', 'update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const isOpen = ref(false);
const selectedValues = ref<string[]>([...props.modelValue]);
const dropdownRef = ref<HTMLElement | null>(null);

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const handleClickOutside = (event: MouseEvent) => {
  if (isOpen.value && dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    isOpen.value = false;
  }
};

watch(selectedValues, (newValues) => {
  emit('updateFilters', props.id, newValues);
  if (JSON.stringify(newValues) !== JSON.stringify(props.modelValue)) {
    emit('update:modelValue', newValues);
  }
});

watch(
    () => props.modelValue,
    (newModelValue) => {
      if (JSON.stringify(newModelValue) !== JSON.stringify(selectedValues.value)) {
        selectedValues.value = [...newModelValue];
      }
    },
    { immediate: true }
);

const selectedLabels = computed(() =>
    props.options
        .filter((option) => selectedValues.value.includes(option.value))
        .map((option) => option.label)
);

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "dropdown-multiselect",
    ref_key: "dropdownRef",
    ref: dropdownRef
  }, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(__props.label), 1),
      (__props.tooltip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(TooltipComponent, {
              text: __props.tooltip,
              position: "top"
            }, null, 8, ["text"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["dropdown-trigger", [{'is-active': isOpen.value}, {placeholder: selectedLabels.value.length==0}, {'has-error': __props.hasError}]]),
      onClick: toggleDropdown
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(selectedLabels.value.length ? selectedLabels.value.join(', ') : __props.placeholder), 1),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "caret bp-icon-Chevron" }, null, -1))
    ], 2),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "dropdown-item"
              }, [
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    value: option.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedValues).value = $event)),
                    class: "dropdown-checkbox"
                  }, null, 8, _hoisted_6), [
                    [_vModelCheckbox, selectedValues.value]
                  ]),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "custom-checkbox" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(option.label), 1)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.hasError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 512))
}
}

})